<template>
  <div class="nominate_large_card_container">
    
    <!-- SPONSORSHIP BOX -->
    <sponsorship-box
    v-show="sponsor_list.length > 0" 
    title="This contest sponsored by:"
    :sponsors="sponsor_list"
    ></sponsorship-box>

    <div class="nominate_large_card">
      
      <!-- CONTEST NAME HEADER -->
      <div class="nominate_large_card_header">
        <div class="container">
          <div class="row">
            <div class="col-2">
              <span class="nominate_large_card_icon_container"
              v-if="contest.icon"
              >
                <font-awesome-icon :icon="contest.icon"></font-awesome-icon>
              </span>
            </div>
            <div class="col-10">
              {{contest.label}}
            </div>
          </div>
        </div>
      </div>

      <!-- CONTEST IMAGE -->
      <div class="contest_image" 
      v-if="contest.lead_image"
      :style="{'background-image': 'url(' + resize_cms_image(contest.lead_image) + ')' }"
      ></div>

      <!-- SHARE ROW -->
      <large-social-share
      v-if="nom_share_status"
      share_type="nomination"
      :contest="contest"
      ></large-social-share>

      <social-share-row
      v-if="!nom_share_status"
      share_type="nomination"
      :contest="contest"
      ></social-share-row>
      
      <div class="container"
      v-if="!nom_share_status"
      >
          <div class="row">
            <div class="col-12">

              <vue-bootstrap-typeahead
              v-model.trim="contest_nomination_text"
              placeholder="Type nomination..."
              :serializer="s => s.nomination_text"
              :data="nomination_suggestions"
              size="lg"
              inputClass="bod_input_field"
              backgroundVariant="info"
              textVariant="white"
              >
              </vue-bootstrap-typeahead>
              
            </div>
          </div>

          <div class="row">

            <div class="col-12">

              <transition 
              name="" 
              mode="out-in"
              enter-active-class="animated tada faster" 
              leave-active-class="animated pulse faster" 
              >

                <!-- IF -->
                <button class="btn btn-primary" type="button" 
                :disabled="nomination_save_in_progress"
                :class="{disabled: nomination_save_in_progress}"
                @click="record_nomination"
                v-if="!save_status"
                key="nominate"
                >

                  <span
                  v-show="!nomination_save_in_progress"
                  >
                    Nominate
                  </span>

                  <span
                  v-show="nomination_save_in_progress"
                  >
                    ...
                  </span>
                  
                </button>
                <!-- END IF -->

                <!-- ELSE -->
                <button class="btn btn-success" type="button"
                @click="reset_nomination()"
                key="confirmation"
                v-else
                >
                  <font-awesome-icon icon="check-circle"></font-awesome-icon>
                </button>
                <!-- END ELSE -->

              </transition>

            </div>

          </div>

        </div>

    </div>

  </div>
</template>

<script>
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import SocialShareRow from '@/components/social/social_share_row.vue';
import LargeSocialShare from '@/components/social/large_social_share.vue';
import SponsorshipBox from '@/features/sponsorships/sponsorship_box.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faEnvelopeSquare,
  faLongArrowAltRight
} from '@fortawesome/free-solid-svg-icons';
import { 
  faFacebookSquare,
  faTwitterSquare
} from '@fortawesome/free-brands-svg-icons';
library.add(
  faUtensils, 
  faShoppingCart, 
  faSmileBeam,
  faTaxi,
  faUsers,
  faBowlingBall,
  faFilm,
  faShoppingBasket,
  faSwimmer,
  faMapMarkedAlt,
  faCaretRight,
  faCaretDown,
  faFacebookSquare,
  faTwitterSquare,
  faEnvelopeSquare,
  faLongArrowAltRight
);

export default {
  name: 'nominate_large_card',
  props: [
    'contest',
    'instance_contestid',
    'nomination_save_status',
    'nomination_save_in_progress',
    'reset_nomination_requested'
  ],
  data () {
    return {
      contest_nomination_text: '',
      save_status: this.nomination_save_status
    }
  },
  created() {
    this.update_card_data();
  },
  mounted() {
  },
  beforeUpdate() {
    
  },
  updated() {
    
  },
  watch: { 
    nomination_save_status: function(new_val, old_val) {
      let vm = this;
      vm.save_status = new_val;
    },
    reset_nomination_requested: function(new_val, old_val) {
      let vm = this;

      if(new_val === true) {
        vm.reset_nomination();
      }
    },
    contest: function(new_val, old_val) {
      this.update_card_data();
    }
  },
  computed: {
    sponsor_list: function() {
      return this.$root.store.contests.get_current_contest_sponsors(this.instance_contestid);
    },
    nomination_suggestions: function() {
      return this.$root.store.nominations.get_current_nomination_suggestions_by_contest(this.instance_contestid);
    },
    nom_share_status: function() {
      return this.$root.store.nominations.get_current_nom_share_status();
    }
  },
  methods: {
    reset_nomination: function() {
      this.contest_nomination_text = '';
      this.$emit('request_nomination_reset', '');
    },
    record_nomination: function() {
      let vm = this;

      if(vm.contest_nomination_text != '') {
        vm.$emit('record_nomination_from_contest', vm.contest_nomination_text);
      }
    },
    resize_cms_image: function(value) {
      if(value.indexOf('/rw/') > 0) {
        return value.replace(/\/rw\//g, '/rf/image_md/');
      }
      else {
        return value;
      }
    },
    update_card_data: function() {
      this.$root.store.contests.get_contest_sponsors(this.instance_contestid);
      this.$root.store.nominations.get_nomination_suggestions_by_contest(this.instance_contestid);
    }
  },
  /*metaInfo() {
    return {
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: this.contest.label
        }
      ]
    }
  },*/
  filters: {
    
  },
  components: {
    VueBootstrapTypeahead,
    SocialShareRow,
    SponsorshipBox,
    LargeSocialShare
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '@/styles/global_styles.scss';

.nominate_large_card {
  margin: 1em;
  box-shadow: 1px 1px 10px 0px #aaa;
  padding-bottom: 1em;

  .nominate_large_card_header {
    background: $dcom-purple;
    color: #FFF;
    font-size: 1.4em;
    padding: 0.5em 0;
    border-bottom: solid 4px #916c96;
  }

  .contest_image {
    width: 100%;
    height: 150px;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    /*margin-bottom: 1em;*/
  }

  .bod_input_field {
    font-size: 1rem;
  }

  .btn {

  }
  
}

.button-enter {
  opacity: 0;
}

.nominate_large_card {
  /*padding: 1em 0;*/

  .nomination_actions {
    padding: 1em 0;
  }

  .btn, input {
    width: 100%;
    height: 100%;
  }

  .btn {
    /* position: absolute;
    height: 38px; */
  }

  .sponsorship_box_container {
    margin-bottom: 1em;
  }
}


</style>


// WEBPACK FOOTER //
// src/features/nominate/nominate_card_large.vue